.time-display {
  display: inline-block;
  font-size: 1.4rem;
  color: #e3e4e7;
  border-radius: 0.4rem;
  margin: 0 -1.2rem;
  padding: 0.8rem 1.2rem;
  transition: all 100ms ease-in-out;
  cursor: pointer;
  text-align: center;

  &[data-background-visible='true'] {
    background-color: #31343c;
    color: var(--color-grayscale-white, #fafafa);
  }

  &:hover,
  &:focus-visible {
    cursor: pointer;
    color: var(--color-grayscale-white);
    background-color: var(--color-grayscale-arsenic);
  }

  &:active {
    border-color: var(--color-secondary);
  }

  &[data-disabled='true'] {
    &:hover,
    &:focus-visible {
      cursor: default;
      background-color: transparent;
      color: var(--color-grayscale-ghost);
    }
  }
}
